import React from 'react';

export default class GriffInput extends React.Component {

    bild(product) {
        const bild = product.Bild || "default.png";
        const url = SETTINGS.wkfgContentBaseUrl + bild;
        return url;
    }

    render() {
        const products = APP.findProductsByReiter(APP.arrangement.isShojituer() ? 'Shojigriffe' : 'Griffe');
        return (
            <div>
                <fieldset>
                    {products.map((product, index) =>
                        <div key={index}
                             className={"productdrag image-text stop-select selectable "+(product.Artikelnummer==this.props.value?'selected':'')}
                             onClick={()=>this.props.setValue(product.Artikelnummer)}>
                            <div className="image no-pointer" style={{backgroundImage:'url("'+this.bild(product)+'")'}}></div>
                            <div className="text">{product.Name}</div>
                            <div className="info" onClick={()=>APP.uiHandler.showHelpPopup(product)}></div>
                        </div>
                    )}
                </fieldset>
            </div>
        )
    }

}
